import { createFileRoute } from '@tanstack/react-router';
import DepthChartPage from '../../../../../pages/lineups/DepthChartPage';

export const Route = createFileRoute(
  '/_authenticated/$owner/active/$team_season_id/depth-chart'
)({
  component: DepthChartPage
});
